import { FC } from "react";
import { Message } from "ai/react";
import Markdown from "react-markdown";
import RectTailLeft from "@/assets/images/rect_tail_left.svg";
import Avatar from "@/assets/images/avatar.svg";
import { DotLoading } from "@/components/DotLoading";
import { Link } from "react-router-dom";

type ChatAssistantMessageType = "normal" | "loading" | "first";
interface ChatAssistantMessageProps {
  type: ChatAssistantMessageType;
  className?: string;
  firstMessage?: string;
  message?: Message;
  messageLinkType?: "blank" | "self";
}

export const ChatAssistantMessage: FC<ChatAssistantMessageProps> = (props) => {
  const { type, firstMessage, message, messageLinkType = "blank" } = props;

  return (
    <div className="flex w-full items-end pb-4">
      <img src={Avatar} className="-mb-4 h-8 w-8" />
      <img src={RectTailLeft} className="mb-2 h-2 w-2" />

      <div className="max-w-[calc(100%-48px)] whitespace-pre-line break-words rounded-md bg-[#eee] p-2">
        {type === "normal" && (
          <Markdown
            className="markdown-content text-sm"
            components={{
              a: ({ ...props }) => {
                return (
                  <Link
                    {...props}
                    to={(props.href + `&timestamp=${Date.now()}`) as string}
                    target={`_${messageLinkType}`}
                    rel="noopener noreferrer"
                    replace
                    className="text-blue-600 underline underline-offset-4"
                  />
                );
              },
            }}
          >
            {message?.content}
          </Markdown>
        )}

        {type === "loading" && (
          <div className="py-2">
            <DotLoading />
          </div>
        )}

        {type === "first" && (
          <p style={{ wordWrap: "break-word" }} className="whitespace-pre-wrap text-sm">
            {firstMessage}
          </p>
        )}
      </div>
    </div>
  );
};
